import ReactPlayer from 'react-player'
import ButtonLink from 'components/ButtonLink'
import {
  Card,
  CardContent,
  CardMedia,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { Description, OpenInNew } from '@mui/icons-material'

export default function AndreaHome() {
  const theme = useTheme()

  return (
    <>
      <Stack
        mb={2}
        spacing={2}
        useFlexGap
        alignItems='center'
        width={{ xs: '100%', sm: '70%' }}>
        <Stack
          flexDirection='row'
          alignItems='center'
          justifyContent='center'
          flexWrap='wrap'
          gap={2}>
          <Typography
            variant='h1'
            color='primary.main'
            fontSize='clamp(3rem, 10vw, 3.5rem)'
            ml={2}>
            ANDREA
          </Typography>
          <Typography
            variant='h1'
            display='flex'
            alignItems='center'
            fontSize='clamp(3rem, 10vw, 3.5rem)'>
            HERRMANN
          </Typography>
        </Stack>
        <Typography
          textAlign='center'
          color='text.secondary'
          my={3}
          width={{ sm: '100%', md: '80%' }}>
          Award-winning HCP and patient copywriter with over 11 years of
          experience in pharmaceutical advertising specializing in marrying the
          data, strategy, and creative to tell a compelling story.
        </Typography>
      </Stack>
      <ButtonLink
        label='Resume'
        link='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/A_Herrmann_Resume%201_9_25.pdf'
        startIcon={<Description />}
        endIcon={<OpenInNew />}
        color='primary'
        bold={true}
      />
      <Stack
        flexDirection='row'
        justifyContent='center'
        flexWrap='wrap'
        gap={3}
        mt={6}
        width='100%'>
        <Typography
          variant='body2'
          width='100%'
          color='grey'
          textTransform='uppercase'
          textAlign='center'>
          Work samples:
        </Typography>
        <ButtonLink
          label='Digital & Print Materials'
          link='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/Digital%20and%20Print%20Materials_v2.pdf'
          endIcon={<OpenInNew />}
          color='error'
        />
        <ButtonLink
          label='Congress Materials'
          link='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/Congress%20.pdf'
          endIcon={<OpenInNew />}
          color='warning'
        />
        <ButtonLink
          label='Concepts'
          link='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/Concepts_2025.pdf'
          endIcon={<OpenInNew />}
          color='success'
        />
        {/* <Stack
          width={640}
          maxWidth='100%'
          boxShadow={2}
          sx={{
            transition: '0.2s all ease-in-out',
            '&:hover': { boxShadow: 5 },
          }}>
          <ReactPlayer
            url='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/Mirum%20Booth_med%20res_v2.mp4'
            height={null}
            width='100%'
            controls
          />
        </Stack>
        <Stack width='100%' alignItems='center'>
          <Card
            sx={{
              width: 640,
              maxWidth: '100%',
              boxShadow: 2,
              transition: '0.2s all ease-in-out',
              '&:hover': { boxShadow: 5 },
            }}>
            <CardMedia>
              <ReactPlayer
                url='https://storage.googleapis.com/herrmann-media.appspot.com/andrea/Mirum%20Booth_med%20res_v2.mp4'
                height={null}
                width='100%'
                controls
              />
            </CardMedia>
            <CardContent>
              <Typography
                gutterBottom
                variant='h6'
                component='div'
                sx={{ color: theme.palette.info.main }}>
                Video title example
              </Typography>
              <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                Video description exmaple
              </Typography>
            </CardContent>
          </Card>
        </Stack> */}
      </Stack>
    </>
  )
}
